import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function Footer() {
  const { user } = useAuth();
  return (
    <footer className="border-t border-[var(--border)] bg-[var(--bg)] mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src="/phm-logo.png" alt="PHM" className="w-11 h-11 object-cover border border-[var(--border)]" />
            <span className="font-display font-semibold">PHMEG Evaluation Group LLC</span>
          </div>
          <p className="text-sm text-[var(--text-2)] leading-relaxed">
            A Nevada-based research and evaluation firm helping agencies, nonprofits, and health systems measure impact through a health equity-centered lens.
          </p>
        </div>

        <div>
          <div className="overline mb-4">Navigate</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-[var(--text-2)] hover:text-white">About</Link></li>
            <li><Link to="/services" className="text-[var(--text-2)] hover:text-white">Services</Link></li>
            {user && user.role === "admin" && (
              <li><Link to="/grant-writer" className="text-[var(--text-2)] hover:text-white">AI Grant Engine</Link></li>
            )}
            <li><Link to="/case-studies" className="text-[var(--text-2)] hover:text-white">Case Studies</Link></li>
            <li><Link to="/pricing" className="text-[var(--text-2)] hover:text-white">Pricing</Link></li>
            <li><Link to="/resources" className="text-[var(--text-2)] hover:text-white">Resources</Link></li>
            <li><Link to="/book-consultation" className="text-[var(--text-2)] hover:text-white">Book Consultation</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Account</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/login" className="text-[var(--text-2)] hover:text-white">Sign in</Link></li>
            <li><Link to="/register" className="text-[var(--text-2)] hover:text-white">Create account</Link></li>
            <li><Link to="/portal" className="text-[var(--text-2)] hover:text-white">Client Portal</Link></li>
            <li><Link to="/contact" className="text-[var(--text-2)] hover:text-white">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--border)] py-6 px-6 lg:px-10 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[var(--text-3)]">
        <div data-testid="footer-company-name">© {new Date().getFullYear()} PHMEG Evaluation Group LLC. All rights reserved.</div>
        <div className="flex items-center gap-4">
          <Link to="/compliance" className="hover:text-white" data-testid="footer-compliance-link">Compliance, ADA &amp; Equity Statements</Link>
          <span className="uppercase tracking-[0.22em]">Evidence · Equity · Impact</span>
        </div>
      </div>
    </footer>
  );
}
